<template>
    <div class="dk-slide swiper-slide">
        <slot></slot>
        <div v-if="lazy" class="swiper-lazy-preloader"></div>
    </div>
</template>

<script>
export default {
    name: 'DkSlide',
    computed: {
        lazy() {
            return this.$parent &&
                this.$parent.$options.name === 'swiper' &&
                this.$parent.$props.options &&
                this.$parent.$props.options.lazy;
        },
    },
};
</script>

<style lang="scss" src="@v4/common/components/atoms/DkSlide/_index.scss"></style>
